<template>

	<div>
		<b-table :items="invoicesList"
				 :current-page="currentPage"
				 :per-page="perPage"
				 :fields="tableFields"
				 :busy="loading"
				 show-empty
				 striped
				 empty-filtered-text="No hay facturas disponibles"
				 empty-text="No hay facturas disponibles"
				 head-variant="light">
			<div slot="Date" slot-scope="item">
				{{item.item.Date | dateFormat}}
			</div>

			<div v-if="item.item.Currency" slot="Total" slot-scope="item">
				{{item.item.Total | currency(
				item.item.Currency.Symbol, configSeparator, configFractionCount,
				configFractionSeparator, configSymbolPosition, configSymbolSpacing
				)}}
			</div>

			<div v-else slot="Total" slot-scope="item">
				{{item.item.Total}}
			</div>

			<div v-if="item.item.Currency" slot="Balance" slot-scope="item">
				{{item.item.Balance | currency(
				item.item.Currency.Symbol, configSeparator, configFractionCount,
				configFractionSeparator, configSymbolPosition, configSymbolSpacing
				)}}
			</div>

			<div v-else slot="Balance" slot-scope="item">
				{{item.item.Balance}}
			</div>

			<div slot="Details" slot-scope="item">
				<router-link :to="{name: 'InvoiceDetail', params: {id: item.item.Id}}">
					Ver
				</router-link>
			</div>

			<template v-slot:table-busy>
				<div class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
				</div>
			</template>
		</b-table>
		<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
			<b-pagination
				:total-rows="totalRows"
				:per-page="perPage"
				v-model="currentPage"
				prev-text="<<"
				next-text=">>"
				hide-goto-end-buttons/>
		</nav>
	</div>

</template>

<script>
	export default {
		name: "InvoiceTableComponent",
		props: {
			invoicesList: Array,
			loader: Boolean
		},
		data: function () {
			return {
				perPage: 10,
				currentPage: 1,
				loading: false,
				tableFields: {
					Number: {
						label: 'Número de Factura'
					},
					Date: {
						label: 'Fecha de la Factura'
					},
					Total: {
						label: 'Total'
					},
					Balance: {
						label: 'Saldo'
					},
					Company: {
						label: 'Empresa'
					},
					Details: {
						label: 'Detalles'
					}
				},
				configSeparator: '.',
				configFractionCount: 2,
				configFractionSeparator: ',',
				configSymbolPosition: 'front',
				configSymbolSpacing: false
			}
		},
		computed: {
			totalRows: function () {
				return this.invoicesList.length;
			}
		}
	}
</script>

<style scoped>

</style>
